import { cleanPhone } from '../phone';
export var formatPhone = function formatPhone(phone) {
  var phoneNumber = cleanPhone(phone);
  if (phoneNumber.length <= 6) {
    return phoneNumber.replace(/(\d{3})(\d{1,3})/, '$1 $2');
  }
  if (phoneNumber.length <= 8) {
    return phoneNumber.replace(/(\d{3})(\d{3})(\d{0,2})/, '$1 $2-$3');
  }
  return phoneNumber.replace(/(\d{3})(\d{3})(\d{2})(\d{0,2})/, '$1 $2-$3-$4');
};